const Configuration = {
  env: process.env.NODE_ENV,
  sentryOrganizationId: process.env.SENTRY_ORGANIZATION_ID,
  sentryProjectId: process.env.SENTRY_PROJECT_ID,
  sentryKey: process.env.SENTRY_KEY,
  sentryEnvironment: process.env.SENTRY_ENVIRONMENT,
  sentryReleaseVersion: process.env.GIT_REVISION,
  plaidEnv: process.env.PLAID_ENV,
  plaidKey: process.env.PLAID_KEY,
  stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
  amplitudeApiKey: process.env.AMPLITUDE_KEY,
  statuspageEmbedCode: process.env.STATUSPAGE_EMBED_CODE,
  newRelicAccountId: process.env.NEW_RELIC_ACCOUNT_ID,
  newRelicLicenseKey: process.env.NEW_RELIC_LICENSE_KEY,
  newRelicApplicationId: process.env.NEW_RELIC_APPLICATION_ID,
  googleMapsKey: `&key=${process.env.GOOGLE_MAPS_JS_KEY}`,
  googleRecaptchaSiteKey: process.env.GOOGLE_RECAPTCHA_SITE_KEY,
  smartlookProjectKey: process.env.SMARTLOOK_PROJECT_KEY,
  apiUrl: process.env.API_URL,
  apiVersion: process.env.API_VERSION,
  intercomAppId: process.env.INTERCOM_APP_ID,
  release: process.env.GIT_REVISION,
};

module.exports = Configuration;
